/* eslint-disable @typescript-eslint/ban-types */
import React from 'react';
import { Cell, ColumnInterface } from 'react-table';

import {
    defaultCellWidth,
    defaultTooltipPosition,
} from '@trqk/components/src/table/constants';
import { Tooltip } from '@trqk/components';

import { COLUMN_IDS, EXTRA_CELL_WIDTH } from '../../constants';

export interface TooltipColumn extends ColumnInterface<TrqkGapChannelAudio> {
    tooltipPosition: TooltipPosition;
    withTooltip?: boolean;
}

interface Props {
    cell: Cell<TrqkGapChannelAudio>;
    column: TooltipColumn;
}

export function ChannelNameCell({ cell, column }: Props): JSX.Element {
    const position = column?.tooltipPosition ?? defaultTooltipPosition;
    const colWidth =
        typeof column.width === 'number' ? column.width : defaultCellWidth;
    // See notes in ../constants about this extra width
    const width = colWidth + EXTRA_CELL_WIDTH[COLUMN_IDS.CHANNEL_NAME];

    return (
        <Tooltip
            message={cell.value}
            position={position}
            minWidth={250}
            maxWidth={250}
        >
            <div className="flex items-center">
                <div
                    className="leading-tight clamp-2-lines-break-words"
                    style={{
                        width,
                    }}
                >
                    {cell.value}
                </div>
            </div>
        </Tooltip>
    );
}
